
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.57 1l-.593.977a4.24 4.24 0 00-1.024-.524 3.059 3.059 0 00-1.016-.172c-.536 0-1.023.177-1.46.532-.438.354-.792.908-1.063 1.664-.266.755-.398 1.687-.398 2.796 0 1.61.231 2.839.695 3.688.469.844 1.143 1.266 2.023 1.266.48 0 .88-.055 1.204-.165.328-.109.677-.28 1.046-.515l.563.898c-.48.292-.956.505-1.43.64a5.68 5.68 0 01-1.578.204c-.698 0-1.305-.143-1.82-.43a3.58 3.58 0 01-1.281-1.218C1.099 10.109.846 9.474.68 8.734a11.29 11.29 0 01-.25-2.476c0-1.219.182-2.284.547-3.196.37-.916.9-1.62 1.593-2.109.693-.495 1.5-.742 2.422-.742.401 0 .81.062 1.227.187C6.64.523 7.09.724 7.57 1z","fill":"currentColor"}})])
          )
        }
      }
    